var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_vm.form.filters.analitico ? _c('div', [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacaoAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacaoAnalitico", $$v);
      },
      expression: "form.filters.formacaoAnalitico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Origem da Formação",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.origens,
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.origemIdAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "origemIdAnalitico", $$v);
      },
      expression: "form.filters.origemIdAnalitico"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data de Solicitação",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataSolicitacaoAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataSolicitacaoAnalitico", $$v);
      },
      expression: "form.filters.dataSolicitacaoAnalitico"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data de Realização",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataRealizacaoAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataRealizacaoAnalitico", $$v);
      },
      expression: "form.filters.dataRealizacaoAnalitico"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicioAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicioAnalitico", $$v);
      },
      expression: "form.filters.dataInicioAnalitico"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFimAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFimAnalitico", $$v);
      },
      expression: "form.filters.dataFimAnalitico"
    }
  }), _c('sigfoco-switch-button', {
    attrs: {
      "cols": 2,
      "label": "Tipo de Relatório",
      "labelChecked": "Analítico",
      "labelUnchecked": "Sintético"
    },
    model: {
      value: _vm.form.filters.analitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "analitico", $$v);
      },
      expression: "form.filters.analitico"
    }
  })], 1)], 1) : _c('div', [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Origem da Formação",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.origens,
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.tipoFormacaoSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "tipoFormacaoSintetico", $$v);
      },
      expression: "form.filters.tipoFormacaoSintetico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga Horária Total",
      "outlined": "",
      "inputmode": "numeric",
      "dense": ""
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica
    },
    model: {
      value: _vm.form.filters.cargaHorariaSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "cargaHorariaSintetico", $$v);
      },
      expression: "form.filters.cargaHorariaSintetico"
    }
  })], 1), _c('sigfoco-switch-button', {
    attrs: {
      "cols": 2,
      "label": "Tipo de Relatório",
      "labelChecked": "Analítico",
      "labelUnchecked": "Sintético"
    },
    model: {
      value: _vm.form.filters.analitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "analitico", $$v);
      },
      expression: "form.filters.analitico"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicioSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicioSintetico", $$v);
      },
      expression: "form.filters.dataInicioSintetico"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFimSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFimSintetico", $$v);
      },
      expression: "form.filters.dataFimSintetico"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": _vm.buscarRelatorios
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": _vm.resetForm
    }
  })], 1)], 1)]), _vm.form.mostrarAnalitico ? _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.getFilteredHeader(_vm.headersAnalitico),
      "items": _vm.form.lists.listRelatorioAnalitico,
      "items-per-page": _vm.form.itemsPerPage,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.formacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.formacao) + " ")];
      }
    }, {
      key: `item.origem`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.origem) + " ")];
      }
    }, {
      key: `item.dataSolicitacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.dataSolicitacao) + " ")];
      }
    }, {
      key: `item.dataRealizacao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.dataRealizacao) + " ")];
      }
    }, {
      key: `item.qtdPrevistas`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.qtdPrevistas) + " ")];
      }
    }, {
      key: `item.qtdPresentes`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(item.qtdPresentes) + " ")];
      }
    }, {
      key: `item.cargaHoraria`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(item.cargaHoraria) + " ")];
      }
    }], null, true)
  }) : _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.getFilteredHeader(_vm.headersSintetico),
      "items": _vm.form.lists.listRelatorioSintetico,
      "items-per-page": _vm.form.itemsPerPage,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.origem`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(item.origem) + " ")];
      }
    }, {
      key: `item.cargaHoraria`,
      fn: function (_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(item.cargaHoraria) + " ")];
      }
    }, {
      key: `item.qtdFormacoes`,
      fn: function (_ref0) {
        var item = _ref0.item;
        return [_vm._v(" " + _vm._s(item.qtdFormacoes) + " ")];
      }
    }, {
      key: `item.qtdPrevistas`,
      fn: function (_ref1) {
        var item = _ref1.item;
        return [_vm._v(" " + _vm._s(item.qtdPrevistas) + " ")];
      }
    }, {
      key: `item.qtdPresentes`,
      fn: function (_ref10) {
        var item = _ref10.item;
        return [_vm._v(" " + _vm._s(item.qtdPresentes) + " ")];
      }
    }, {
      key: `item.qtdAusentes`,
      fn: function (_ref11) {
        var item = _ref11.item;
        return [_vm._v(" " + _vm._s(item.qtdAusentes) + " ")];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorioAnalitico.length > 0 || _vm.form.lists.listRelatorioSintetico.length > 0 ? _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": _vm.baixarRelatorioPdf,
      "cancel": _vm.baixarCSVRelatorio
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }